document.querySelectorAll('.ra_enable_articles button.article-load-ml').forEach(button => {
    button.addEventListener('click', function(){
        button.closest('.ra_enable_articles').classList.toggle('show_more');
    });
});


document.querySelectorAll("a.bhs_scroll-down").forEach(function (link) {
  link.addEventListener("click", function (e) {
    e.preventDefault();

    const target = this.getAttribute("href"); // "#section-id"

    if (target && document.querySelector(target)) {
      const offsetTop = document.querySelector(target).offsetTop - 100;
      console.log('target ',document.querySelector(target).offsetTop);

      window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
    }
  });
});

/* Make navbar active on scroll */

const subtopicSections = document.querySelectorAll(".swd-wrap");
const subtopicNavLinks = document.querySelectorAll(".caw-subtopics-title");

const sections = document.querySelectorAll(".swd-wrap");
const navLinks = document.querySelectorAll(".caw-subtopics-title");

// Scroll → Highlight active menu
window.addEventListener("scroll", () => {
let current = "";

sections.forEach(section => {
  const sectionTop = section.offsetTop - 200;
  if (window.scrollY >= sectionTop) {
    current = section.getAttribute("id");
  }
});

navLinks.forEach(link => {
  link.classList.remove("active");
  if (link.getAttribute("data-id") === "#" + current) {
    link.classList.add("active");

    const container = document.querySelector('.bhs_side-inner');
    container.scrollTo({ top: link.offsetTop, behavior: 'smooth' });

    const titleEl = link.querySelector('.caw-st-title');
    const closeBtn = link.closest('.bhs_side-nav')?.querySelector('.bhs_mh-close');

    if (titleEl && closeBtn) {
      closeBtn.innerHTML = `${titleEl.dataset.numbering} ${titleEl.innerHTML}`;
    }
  }
});
});

/* chapter sidebar accordian code */
// document.querySelectorAll('.caw-chapter-wrap.has-subtopic .caw-title').forEach(chapter => {
//    chapter.addEventListener('click', function(){
//       chapter.closest('.caw-chapter-wrap.has-subtopic').classList.toggle('active'); 
//    });
// });

document.querySelectorAll('.caw-chapter-wrap .caw-title').forEach(item => {
    item.addEventListener('click', function () {
        const link = item.closest('.caw-chapter-wrap').querySelector('a.chapter_number');
        if (link) {
            link.click();
        }
    });
});

document.querySelectorAll('.bhs_side-nav .bhs_mobile-header').forEach(item => {
    item.addEventListener('click', function(){
       item.closest('.bhs_side-nav').classList.toggle('close');
        item.closest('.bhs_side-nav').classList.toggle('open');
        document.querySelector('body').classList.toggle('open-cc-blog');
    });
});



